import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "@solana/wallet-adapter-react-ui/styles.css";
import firebase from "./utils/firebase";
import SolanaProvider from "./contexts/SolanaProvider";

//const root = ReactDOM.createRoot(document.getElementById("root"));
ReactDOM.render(
   <React.StrictMode>
     <SolanaProvider>
       <App />
     </SolanaProvider>
   </React.StrictMode>,
   document.getElementById('root')
  //<App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
